import {Button, Grid, Paper, TextField, Typography} from "@mui/material";
import * as React from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import axios from "axios";
import {PopupMessage} from "../../utils/message";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { LoadingIndicator } from "../../components/LoadingIndicator";
import Logger from "@ioc:Adonis/Core/Logger";

export class UnfinishedTutorial extends React.Component<any, any> {
    constructor(props) {
        super(props);

        this.state = {
            unfinishedAmount: 0,
            amount: 0,
            offset: 0,
            userToDelete: "",
            users: [],
            progress: {},
            progressInterval: null,
            loading: false,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    componentWillUnmount(): void {
        this.clearInterval();
    }

    async fetchData() {
        const url = `${Config.getInstance.apiUrl}/api/users/unfinished_tutorial_amount`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const response = await axios.get(url, {headers});

        const data = response.data;
        const success = data.success;

        if (success) {
            const unfinishedAmount = data.amount;
            this.setState({unfinishedAmount});
        } else {
            PopupMessage.error("Fetch Data Failed");
        }
    }

    onDelete = async () => {
        const url = `${Config.getInstance.apiUrl}/api/users/delete_unfinished_tutorial`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }
        const userIds = this.state.userToDelete;

        this.startInterval();

        this.setState({loading: true});

        const response = await axios.post(url, {userIds}, {headers});

        this.setState({loading: false});

        // this.clearInterval();

        if (response.data.success) {
            PopupMessage.success("Delete unfinished tutorial success");
        } else {
            PopupMessage.error("Delete unfinished tutorial failed");
        }
        await this.fetchData();
    }

    onChangeCorruptedUsersValue = (e, key) => {
        this.setState({[key]: e.target.value});
    }

    copyToClipboard = async (text) => {
        navigator.clipboard.writeText(text);

        PopupMessage.success("Copied to clipboard");
    }

    onGetListUnfinishedTutorial = async () => {
        const {offset, amount, users} = this.state;
        
        const url = `${Config.getInstance.apiUrl}/api/users/get_unfinished_tutorial_id`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const body = {
            offset,
            amount,
        }

        const response = await axios.post(url, body, {headers});

        const data = response.data;
        const success = data.success;

        if (success) {
            const users = data.users;
            this.setState({users});

            const userList = users.map((user) => user.id).join(",");

            this.copyToClipboard(userList);
        } else {
            PopupMessage.error("get UserIds Failed");
        }
    }

    startInterval = () => {
        const progressInterval = setInterval(() => {
            this.getProgress();
        }, 1000);

        this.setState({progressInterval});
    }

    clearInterval = () => {
        const {progressInterval} = this.state;
        if (progressInterval) {
            clearInterval(progressInterval);
        }
    }

    getProgress = async () => {
        const url = `${Config.getInstance.apiUrl}/api/users/unfinished_tutorial_progress`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        };

        const response = await axios.get(url, {headers});

        if (response.data.success) {
            const progress = response.data.progress;

            this.setState({progress});

            if(progress.finished) {
                this.clearInterval();
            }
        }
    }

    renderProgress = () => {
        /*
        const deleteUnfinishedTutorialProgress = {
            totalUser: 0,
            currentUser: 0,
            failedUsers: [] as any[],
        }
        */

        const {progress} = this.state;

        // If progress is empty, return empty string
        if (Object.keys(progress).length === 0) {
            return "";
        }

        const str = `
            Progress: ${progress.currentUser}/${progress.totalUser}.
            Failed Users: ${progress.failedUsers.length}
        `;

        return <Typography variant="h6">
            {str}
            <ContentCopyIcon
                onClick={() => this.copyToClipboard(JSON.stringify(progress.failedUsers))}
            />
        </Typography>;
    }


    renderContent() {
        const styles = {
            h5: {display: "flex", alignItems: "center", justifyContent: "center", marginBottom: '10px'},
            h6: {display: "flex", alignItems: "center", marginBottom: '10px'},
        }

        return <Grid container sm={12} spacing={2}>
            <Grid item container sm={6} rowSpacing={2} style={styles.h5}>
                <Grid sm={8}>
                    <Typography variant="h5">Get Data</Typography>
                </Grid>
                <Grid container style={styles.h6}>
                    <Grid item sm={2}>
                        <Typography variant="h6">Offset:</Typography>
                    </Grid>
                    <Grid item sm={6}>
                        <TextField
                            inputProps={{type: "number"}}
                            value={this.state.offset}
                            onChange={(e) => this.onChangeCorruptedUsersValue(e, "offset")}
                        />
                    </Grid>
                </Grid>

                <Grid container style={styles.h6}>
                    <Grid item sm={2}>
                        <Typography variant="h6">Amount:</Typography>
                    </Grid>
                    <Grid item sm={6}>
                        <TextField
                            inputProps={{type: "number"}}
                            value={this.state.amount}
                            onChange={(e) => this.onChangeCorruptedUsersValue(e, "amount")}
                        />
                    </Grid>
                </Grid>

                <Grid container style={styles.h6}>
                    <Button
                        disableElevation
                        variant="contained"
                        color="primary"
                        onClick={this.onGetListUnfinishedTutorial}
                    >
                        Copy to clipboard
                    </Button>
                </Grid>
            </Grid>

            <Grid item container sm={6} rowSpacing={2} style={styles.h5}>
                <Grid item sm={12}>
                    <Typography variant="h5">Fix User Data</Typography>
                </Grid>

                <Grid item sm={12}>
                    <TextField
                        placeholder="Enter user ids separated by comma, ex: 1,2,3"
                        value={this.state.userToDelete}
                        onChange={(e) => this.onChangeCorruptedUsersValue(e, "userToDelete")}
                        multiline
                        rows={5}
                        fullWidth
                    />
                </Grid>
                <Grid item sm={12}>
                    <Button
                        disableElevation
                        variant="contained"
                        color="primary"
                        onClick={this.onDelete}
                        style={{float: "right"}}
                    >
                        <DeleteIcon />
                        Delete!
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    }

    render() {
        return (
            <div className="contentPadding" style={{width: "100%"}}>
                <div>
                    <Paper className="root" elevation={0}>
                        <Typography variant="h4" style={{marginBottom: '50px'}}>
                            Total Amount: {this.state.unfinishedAmount}
                        </Typography>
                        {this.renderContent()}
                        {this.renderProgress()}
                        {this.state.loading && <LoadingIndicator loadingTextPlaceholder="Deleting unfinished tutorial" loadingText={true}/>}
                    </Paper>
                </div>
            </div>
        );
    }
}